import { fetchUserAttributes } from "@aws-amplify/auth";
import { create } from "@mui/material/styles/createTransitions";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchUserStatus } from "components/Thunks/initAuth";

type User = {
  displayImg: string;
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  appealStatus?: string | null;
};

type UserState = { user?: User };

const initialState: UserState = {
  user: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    logout: (state) => {
      
      state.user = undefined;
    },
    updateDisplayImg: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.displayImg = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserStatus.fulfilled, (state, action) => {
      const user = action.payload;
      if (user) {
        state.user = {
          id: user.sub || "",
          email: user.email || "",
          firstName: user.given_name || "",
          lastName: user.family_name || "",
          displayImg: user.profile || "",
        };
      } else {
        state.user = undefined;
      }
    });
    builder.addCase(fetchUserStatus.rejected, (state) => {
      state.user = undefined;
    });
    builder.addCase(fetchUserStatus.pending, (state) => {
      // state.user = undefined;
    });
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
